<template>
  <div id="home-readme">
    <div class="seperated">
      Hi, I'm <span class="blue bold" style="">Garret Kern</span>. <br />I study
      <span class="magneta">computer science</span> as a junior at
      <span class="magneta">Brown University</span>.
    </div>
    <div class="seperated">
      I have experience in
      <span class="blue"> infosecurity </span>
      and <span class="blue">full-stack engineering</span>.
    </div>
    <div class="seperated">
      This is my personal website, emulating a
      <span class="green">unix</span> style terminal. <br />
      I upload security tutorials and project writeups.
    </div>
    <div class="seperated">
      Type commands and hit enter to see the output. <br />
      Use the <span class="magneta">help</span> command to learn how to navigate. <br />
    </div>
  </div>
</template>

<script>
export default {
  name: "Garret"
};
</script>
